import { APIResponse } from '@hedgit/lib/types/api'

import { post } from '@hedgit/lib/utils/axios'

interface APIVerifyResponse {
  adminExists: false;
}

export const verifyPhoneNumber = async (phoneNumber: string) => {
  try {
    const response = await post<APIResponse<APIVerifyResponse>>('/auth/verify/admin', {
      phone: phoneNumber
    })
    return response.data.adminExists
  } catch (e) {
    return Promise.reject(e)
  }
}
